Backbone.Radio.channel('views').reply('form-stations',function(options){
	var stationData = {
		station:""
	}
	
	var radio = Backbone.Radio.channel('pledgeform')
	
	/*
	 *	Trigger	
	 *		Events
	 */
	var triggerUpdated = function(){
		radio.trigger("stations:updated",stationData)
	}
	
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-stations").html())
		,onAttach:function(){
			//if a station value was passed into the form, select it
			if(Backbone.settings.qs && Backbone.settings.qs.station){ 
				let tmpStation = Backbone.settings.qs.station.toUpperCase();
				this.$el.find('[name="stations"][value="'+tmpStation+'"]').trigger('click'); 
			}
		}
		,events:{
			"click [name=stations]":function(e){
				stationData.station = e.currentTarget.value;
				triggerUpdated();
			}
		}
	})
	
	
	return new (view)();
});